import { type HUImage } from "@modules/types/imageTypes"
import { AnimatePresence, motion } from "motion/react"
import { useState } from "react"
import { Blurhash } from "react-blurhash"

type Props = {
  image?: HUImage
  width: string
  height: string
} & React.ComponentProps<"div">

export function HUImageView({ image, width, height, className, ...props }: Props) {
  const [isImageInCache, setIsImageInCache] = useState<boolean | undefined>()

  return image ? (
    <div style={{ position: "relative", width, height }} {...props}>
      {!isImageInCache && image.hash && (
        <AnimatePresence>
          <motion.div
            animate={{ opacity: [0.4, 0.8, 0.4] }}
            transition={{ duration: 1.5, repeat: Infinity }}
            exit={{ opacity: 0 }}
            style={{ position: "absolute" }}
            className={className}
          >
            <Blurhash hash={image.hash} style={{ flex: 1, width, height }} />
          </motion.div>
        </AnimatePresence>
      )}
      <img
        className={className}
        src={image.url}
        onLoad={() => {
          setIsImageInCache(true)
        }}
        style={{ display: isImageInCache ? "block" : "none", width, height }}
      />
    </div>
  ) : (
    <div className={className} {...props} />
  )
}
